import { useQuery } from 'react-query'
import { graphQLClient } from '../services/authService'
import buzzlUserQueries from '../services/graphql/buzzlUsers/queries'
import { BuzzlUser } from '../types/buzzl-user'

interface Query {
  user: {
    OR: (
      | {
          email_contains: string
          displayName_contains?: undefined
        }
      | {
          displayName_contains: string
          email_contains?: undefined
        }
    )[]
  }
  role?: string
  assignedCustomers_some?: {
    name_contains: string
  }
}

export function useBuzzlUsers(params: { [x: string]: string }) {
  return useQuery<BuzzlUser[], any>(['buzzlUsers', params], async () => {
    const where: Query = {
      user: { OR: [{ email_contains: params.search }, { displayName_contains: params.search }] },
    }

    if (params.role) where.role = params.role
    if (params.customer) where.assignedCustomers_some = { name_contains: params.customer }

    const { buzzlUsers }: { buzzlUsers: BuzzlUser[] | [] } = await graphQLClient.request(
      buzzlUserQueries.getBuzzlUsers,
      {
        orderBy: 'createdAt_DESC',
        where,
      }
    )

    return buzzlUsers
  })
}
